
import Vue, { RenderContext, CreateElement } from 'vue';
import { VLayout as VL, VProgressLinear as VPL, VProgressCircular as VPC } from 'vuetify/lib';
const VLayout = VL as any;
const VProgressLinear = VPL as any;
const VProgressCircular = VPC as any;

/**
 * Overlay para containers.
 *
 * Permite crear una capa semi transparente por encima de cualquier nodo que bloquea la interaccion con el mismo.
 *
 * Se puede agregar un loader (circular en el centro o barra superior) para indicar una carga.
 *
 * **Ejemplo**
 * ```html
 *  <Overlay :dark="isDark" :show="showOverlay" loader="top" color="orange">
 *    <div>Content</div>
 *  </Overlay>
 * ```
 */
export default Vue.extend({
  functional: true,
  props: {
    /** Mostrar el overlay */
    show: Boolean,
    /** Tipo de loader. Puede ser 'top', 'circle' o null (para desactivarlo) */
    loader: { type: String, required: false },
    /** Color del loader */
    color: { type: String, default: 'primary--text' },

    /** Color de fondo del overlay */
    bgColor: { type: String, default: '' },

    /** Activa modo dark */
    dark: Boolean,

    /** Setea height 100% al overlay */
    fillHeight: Boolean
  },
  render(_: CreateElement, ctx) {
    const { data, props } = ctx;

    if (!props.show) return ctx.slots().default;

    // Construir el overlay
    const overlay = [];
    if (props.loader === 'top') {
      overlay.push(<VProgressLinear active indeterminate color={props.color} height={5} background-opacity={0} class='progress-linear' />);
      overlay.push(<div class={{ 'partial-overlay': true, 'dark': props.dark, [props.bgColor]: true }} />);

    } else if (ctx.slots().overlay || props.loader === 'circle') {
      overlay.push(
        <VLayout class={{ 'dark': props.dark, 'partial-overlay align-center justify-center': true, [props.bgColor]: true }}>
          {ctx.slots().overlay || (props.loader === 'circle' && <VProgressCircular indeterminate size={50} color={props.color} />)}
        </VLayout>
      );
    } else if (props.show) {
      overlay.push(<div class={{ 'partial-overlay': true, 'dark': props.dark, [props.bgColor]: true }} />);
    }

    // Devolver el overlay y el contenido atras
    return (
      <div style={data.style} class={
        {
          [props.bgColor]: true, 'fill-height': props.fillHeight, 'loader-container': props.show, ...data.class, [data.staticClass || '']: true }
        }>
        {overlay}
        {ctx.slots().default}
      </div>
    );
  }
});
